var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!!_vm.item)?_c('ViewTargets',{on:{"success":_vm.alertSuccess}}):_vm._e(),_c('TargetsTable',{ref:"table",attrs:{"title":"Users"},on:{"addTargets":_vm.showTargetsModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }